import "@fontsource/kanit/100.css";
import "@fontsource/kanit/200.css";
import "@fontsource/kanit/300.css";
import "@fontsource/kanit/400.css";
import "@fontsource/kanit/500.css";
import "@fontsource/kanit/600.css";
import "@fontsource/kanit/700.css";
import "@fontsource/kanit/800.css";
import "@fontsource/kanit/900.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material";
import { CssBaseline } from "@mui/material";
import MainLayout from "./MainLayout";
import { createContext, useState } from "react";
import LoginSystem from "./loginSystem";
import "./Maps.css";

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      //main: "#1976d2",
      main: "#5172b1",      
    },
    background: { paper: "#223862" },
    //background: { paper: "#393D5E" },
  },
  typography: {
    fontFamily: "kanit",
  },
});
const lightTheme = createTheme({
  palette: {
    mode: "light", 
    primary: {
      //main: "#1976d2",
      main: "#5172b1",      
    },   
  },
  typography: {
    fontFamily: "kanit",
  },
});
export const AppContext = createContext();
function App() {
  const [theme, setTheme] = useState(
    //localStorage.getItem("theme") === "dark" ? darkTheme : lightTheme
    lightTheme
  );
  const handleMode = () => {
    setTheme(theme.palette.mode === "dark" ? lightTheme : darkTheme);
    localStorage.setItem(
      "theme",
      theme.palette.mode === "dark" ? "light" : "dark"
    );
  };
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AppContext.Provider value={{ handleMode }}>
                <MainLayout />
              </AppContext.Provider>
            }
          />
          <Route path="/authen" element={<LoginSystem />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
